import { updatePlayer } from "../api/requests/player.requests.js";
import { EventsConfigService } from "../events_config/events_config_service.js";
import { StatisticsStorage } from "../storage/statistics_storage.js";
import { FeatureTutorialID } from "../storage/feature_tutorial_id.js";

export enum ConveyorTutorialStep
{
  None,
  Widget,
  Play,
  Game,
}

export class ConveyorTutorial
{
  private static step: ConveyorTutorialStep = ConveyorTutorialStep.None;

  private constructor() {}

  public static isPending(): boolean
  {
    const stats = StatisticsStorage.load();
    return EventsConfigService.isEventUnlocked( "conveyor" )
      && !stats.completed_feature_tutorials.includes( FeatureTutorialID.Conveyor )
      && stats.conveyor_best_level === 0
      && stats.conveyor_record_seconds === 0
      && stats.conveyor_lost_level === null;
  }

  public static getStep(): ConveyorTutorialStep
  {
    return ConveyorTutorial.step;
  }

  public static setStep( step: ConveyorTutorialStep ): void
  {
    ConveyorTutorial.step = step;
  }

  public static complete(): void
  {
    ConveyorTutorial.step = ConveyorTutorialStep.None;

    const completed = StatisticsStorage.load().completed_feature_tutorials;
    if ( completed.includes( FeatureTutorialID.Conveyor ) )
      return;

    ConveyorTutorial.save( [ ...completed, FeatureTutorialID.Conveyor ] );
  }

  public static reset(): void
  {
    ConveyorTutorial.step = ConveyorTutorialStep.None;

    const completed = StatisticsStorage.load().completed_feature_tutorials;
    ConveyorTutorial.save( completed.filter( id => id !== FeatureTutorialID.Conveyor ) );
  }

  private static save( completed: number[] ): void
  {
    StatisticsStorage.update( { completed_feature_tutorials: completed } );
    void updatePlayer( { completed_feature_tutorials: completed } )
      .catch( e => console.warn( "[ConveyorTutorial] server sync failed", e ) );
  }
}
